import React from 'react';
import noData from '../assets/images/noData.gif';

export default function NoDataAvailable() {
  return (
    <div className="flex justify-center items-center">
      <img src={noData} loading="lazy" alt="no data available" className="object-fit h-1/3 w-1/3" />
    </div>
  );
}
